<template>
  <div class="row w-100 landing">
    <div class="col-12 col-md-6 landing__panel-wrapper" id="auto">
      <div class="landing__panel"
           :class="[ hoverAuto ? 'auto-layer-hover' : 'kasimas-layer']"
           @mouseover="hoverAuto = true"
           @mouseleave="hoverAuto = false"
           @touchstart="hoverAuto = true"
           @touchend="hoverAuto = false">
        <div class="d-flex justify-content-center align-items-center landing__content">
          <div class="landing__card">
            <h1 class="text-white text-center landing__brand"><span>ARŪNVILKASA</span></h1>
            <h2 class="text-white text-center landing__subtitle"><span>Autoservizo paslaugos</span></h2>
            <div class="text-center">
              <router-link to="/autoservizas">
                <div class="btn btn-dark btn-lg landing__cta">Pažiūrėti</div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 landing__panel-wrapper" id="kasimas">
      <div class="landing__panel"
           :class="[ hoverKasimas ? 'kasimas-layer-hover' : 'auto-layer']"
           @mouseover="hoverKasimas = true"
           @mouseleave="hoverKasimas = false"
           @touchstart="hoverKasimas = true"
           @touchend="hoverKasimas = false">
        <div class="d-flex justify-content-center align-items-center landing__content">
          <div class="landing__card">
            <h1 class="text-white text-center landing__brand"><span>ARŪNVILKASA</span></h1>
            <h2 class="text-white text-center landing__subtitle"><span>Kasimo darbai</span></h2>
            <div class="text-center">
              <router-link to="/kasimo-darbai">
                <div class="btn btn-dark btn-lg landing__cta">Pažiūrėti</div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref} from 'vue';

export default {
  name: "Landing",

  setup() {
    const hoverKasimas = ref(false);
    const hoverAuto = ref(false);

    return {
      hoverAuto,
      hoverKasimas
    }
  }
}
</script>

<style scoped>
.row {
  margin: 0;
}

.col {
  padding: 0;
}

.landing {
  height: 100vh;
  overflow: hidden;
}

.landing__panel-wrapper {
  position: relative;
  height: 50vh;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

@media (min-width: 768px) {
  .landing__panel-wrapper {
    height: 100vh;
  }
}

#auto {
  background-image: url("../assets/auto.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

#kasimas {
  background-image: url("../assets/kasimas.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.landing__panel {
  width: 100%;
  height: 100%;
  min-height: 50vh;
  transition: background-color 0.3s ease;
  cursor: pointer;
}

@media (min-width: 768px) {
  .landing__panel {
    min-height: 100vh;
  }
}

.landing__content {
  width: 100%;
  height: 100%;
  min-height: inherit;
  padding: 20px;
}

.landing__card {
  padding: 32px 28px;
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
}

@media (min-width: 576px) {
  .landing__card {
    max-width: 400px;
    padding: 40px 36px;
  }
}

.landing__panel:hover .landing__card,
.landing__panel:active .landing__card {
  transform: translateY(-6px) scale(1.02);
  background: rgba(0, 0, 0, 0.55);
  border-color: rgba(255, 255, 255, 0.35);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
}

h1, h2 {
  font-family: 'Montserrat', system-ui, -apple-system, 'Segoe UI', Roboto, Arial, sans-serif;
  margin: 0;
}

h1 span, h2 span {
  background-image: linear-gradient(transparent calc(50% - 5px), rgba(255, 255, 255, 0.3) 4px);
  background-size: 0;
  background-repeat: no-repeat;
  display: inline;
  transition: background-size 0.5s ease;
}

h1:hover span, h2:hover span {
  background-size: 100%;
}

.landing__brand {
  font-size: clamp(1.8rem, 5vw, 2.5rem);
  letter-spacing: 0.08em;
  font-weight: 800;
  margin-bottom: 12px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
}

.landing__subtitle {
  font-size: clamp(1rem, 3vw, 1.3rem);
  font-weight: 600;
  opacity: 0.95;
  margin-bottom: 24px;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
}

.landing__cta {
  border-radius: 50px;
  padding: 12px 32px;
  font-weight: 600;
  font-size: clamp(0.95rem, 2.5vw, 1.1rem);
  letter-spacing: 0.05em;
  transition: all 0.3s ease;
  text-transform: uppercase;
  min-height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.landing__cta:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4);
}

.auto-layer {
  background-color: rgba(177, 16, 16, 0.65);
}

.auto-layer-hover {
  background-color: rgba(177, 16, 16, 0.2);
}

.kasimas-layer {
  background-color: rgba(11, 19, 172, 0.65);
}

.kasimas-layer-hover {
  background-color: rgba(11, 19, 172, 0.2);
}

/* Mobile optimizations */
@media (max-width: 767.98px) {
  .landing__content {
    padding: 8px;
  }
  
  .landing__card {
    padding: 24px 20px;
  }
  
  .landing__cta {
    width: 90%;
    max-width: 260px;
  }
}
</style>